import React from "react";
var __jsx = React.createElement;
import PrivacyPolicyComponent from "components/ScreenComponent/PrivacyPolicyComponent";
import Head from "next/head";
export default function HuntTracker() {
  return __jsx(React.Fragment, null, __jsx(Head, null, __jsx("title", null, "WRewards - Privacy Policy")), __jsx(PrivacyPolicyComponent, null));
}